import { React, george, observable, observer, pr, theme, ui } from "aaa";
import * as _ from "lodash";
import SwipeableViews from "react-swipeable-views";
import { PrepaidDesignCode } from "types/card";

export interface IDesign {
    code: PrepaidDesignCode;
    url: string;
}

export class DesignStore {
    @observable selectedDesignCode: PrepaidDesignCode = "B0B";
}

interface IProps {
    store: DesignStore;
    designs: IDesign[];
}

@observer
export class ChooseDesign extends React.Component<IProps, {}> {
    @observable slideIndex = 0;

    constructor(props: IProps) {
        super(props);
        this.slideIndex = _.findIndex(props.designs, d => d.code === props.store.selectedDesignCode);
    }

    onSlide = (newSlideIndex: number) => {
        if (newSlideIndex !== this.slideIndex) {
            this.slideIndex = newSlideIndex;
            this.props.store.selectedDesignCode = this.props.designs[newSlideIndex].code;
        }
    }

    nextSlide = () => {
        this.onSlide(Math.min(this.props.designs.length - 1, this.slideIndex + 1));
    }

    previousSlide = () => {
        this.onSlide(Math.max(0, this.slideIndex - 1));
    }

    render() {
        const entries = this.props.designs.map((design, index) => (
            <img
                key={design.code}
                style={{ width: "100%" }}
                src={require("../../assets/" + design.url)}
                alt={ui.__("a11y.designNumber") + (index + 1)}
            />
        ));

        const buttonStyle = { width: 40, height: 40, background: theme.customColors.georgeBlue, borderRadius: 20 };

        return (
            <>
                <george.SectionTitle style={{ marginTop: 0, marginBottom: theme.MARGIN }}>
                    {ui.__("shop.chooseDesign.title")}
                </george.SectionTitle>
                <pr.HFlexCentered>
                    <div
                        // Need flex to stick arrows nex to card
                        style={{ flex: 1 }}
                    >
                        <div
                            style={{ ...buttonStyle, marginLeft: "auto", visibility: this.slideIndex > 0 ? "visible" : "hidden" }}
                            onClick={this.previousSlide}
                            role="button"
                            aria-label={ui.__("a11y.previousDesign")}
                        >
                            <pr.IconChevronLeft style={{ padding: 8, color: "white" }} />
                        </div>
                    </div>
                    <SwipeableViews
                        // Needs flex: 6 to fix design on S4 mini
                        style={{ maxWidth: 400, margin: "auto", flex: 6 }}
                        enableMouseEvents
                        slideStyle={{ overflow: "hidden" }}
                        index={this.slideIndex}
                        onChangeIndex={this.onSlide}
                    >
                        {entries}
                    </SwipeableViews>
                    <div style={{ flex: 1 }} >
                        <div
                            style={{ ...buttonStyle, visibility: this.slideIndex < this.props.designs.length - 1 ? "visible" : "hidden" }}
                            onClick={this.nextSlide}
                            role="button"
                            aria-label={ui.__("a11y.nextDesign")}
                        >
                            <pr.IconChevronRight style={{ padding: 8, color: "white" }} />
                        </div>
                    </div>
                </pr.HFlexCentered>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/ChooseDesign.tsx